import { Storage } from 'aws-amplify';

export default class UserProfile {
  constructor(data) {
    this.data = data;
  }

  loadAvatar() {
    const imageName = this?.data?.me?.imageName;

    if (imageName && imageName.trim() !== '') {
      return Storage.get(imageName);
    }

    // Return a resolved promise with the default avatar path
    return Promise.resolve('/images/default-avatar.png');
  }
}
